import throwError from './throwError';

const throw404 = () => throwError(404, 'ENOENT');

export default throw404;
